import { render } from "./PolicyRuleTarget.vue?vue&type=template&id=0b0be700&scoped=true"
import script from "./PolicyRuleTarget.vue?vue&type=script&lang=js"
export * from "./PolicyRuleTarget.vue?vue&type=script&lang=js"

import "./PolicyRuleTarget.vue?vue&type=style&index=0&id=0b0be700&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0be700"]])

export default __exports__